export class AppValidatorPattern {
  // constants goes here
  static readonly MIN_LENGTH = 2;
  static readonly MAX_LENGTH = 50;
  static readonly TEXTAREA_MAX_LENGTH = 500;
  static readonly MIN_AMOUNT = 0.01;
  static readonly MIN_ZERO_AMOUNT = 0;
  static readonly MAX_AMOUNT = 999999999.99;
  static readonly MAX_DB_LENGTH = 250;

  // common validator goes here
  static readonly textFieldPattern = /^[A-Za-z0-9 _.-]+$/;
  static readonly phonePattern = /^\d{3}-\d{3}-\d{4}$/;
  static readonly emailPattern =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/;
  static readonly inputPattern = /^[0-9/]+$/;
  static readonly inputPatternwithSpecialCase =
    /^(?!.*(--|''| {2}))[A-Za-z0-9](?:[A-Za-z0-9'-]*[A-Za-z0-9])?(?: [A-Za-z0-9](?:[A-Za-z0-9'-]*[A-Za-z0-9])?)*$/;
  static readonly inputTextAreaPattern =
    /^(?!.*[._-]{2})([A-Za-z0-9]+(?:[._-]?[A-Za-z0-9]+)*(?: [A-Za-z0-9]+(?:[._-]?[A-Za-z0-9]+)*)*)$/;

  // component specific validator goes here
  static readonly namePattern = /^[A-Za-z'-]+$/; // Allow letters, apostrophes, and hyphens
  static readonly fullNamePattern = /^[A-Za-z][A-Za-z.]*$/;
  static readonly nameWithSpacesPattern =
    /^[A-Za-z]+(?:['\\-][A-Za-z]+)*(?: [A-Za-z]+(?:['\\-][A-Za-z]+)*)*$/; // Allow letters, apostrophes, and hyphens but not at start/end or consecutive
  static readonly nonDigitPattern: RegExp = /\D/g;
  static readonly onlyNumbersPattern = /^[0-9]+$/;
  static readonly noSpacesPattern = /^\S*$/;
  static readonly honoreeName: RegExp = /^[A-Za-z]+(?:[ .-][A-Za-z]+)*$/;
  static readonly soldForCash: RegExp = /^[0-9]+(\\.[0-9]{1,2})?$/;
  static readonly startFromZero: RegExp = /^0+/;
  static readonly checkOneORMoreZeroFromStart: RegExp = /^0+[0-9]/;

  static readonly phoneNumberPattern = /^[1-9]\d{9}$/; // Exactly 10 digits, cannot start from 0
  static readonly urlPattern =
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d{1,5})?(\/[^\s]*)?$/;
  static readonly CardHoldername =
    /^(?!.*(--|''| {2}))[A-Za-z](?:[A-Za-z'-]*[A-Za-z])?(?: [A-Za-z](?:[A-Za-z'-]*[A-Za-z])?)*$/;
  static readonly cardExpiryDate = /^(\d{2})\/(\d{2})$/;
  static readonly starMask = /^\*{4,}\d{4}$/;
  static readonly replacesMask = /\s|-/g;
  static readonly lastFourdigitReplace = /\D/g;
  static readonly amountPattern: RegExp = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
  // static readonly numericPattern: RegExp = /(\d+)\s*\/\s*(\d+)/;
  static readonly currencyPattern: RegExp = /\$([\d,]+)\s*\/\s*\$([\d,]+)/;
  static readonly numericExtractPattern: RegExp = /[\d,.]+/;
  static readonly removeCommaPattern: RegExp = /,/g;

  static readonly currencyRemoveNonDigitDotPattern: RegExp = /[^\d.]/g;
  static readonly currencyRemoveLeadingZerosPattern: RegExp = /^0+(?=\d)/;
  static readonly currencyAddCommasPattern: RegExp = /\B(?=(\d{3})+(?!\d))/g;

  static readonly donorNamePattern = /^[A-Za-z]+(?:[-'][A-Za-z]+)*$/;
  static readonly householdNamePattern = /^[A-Za-z0-9\s\-'.&,()]+$/;
  static readonly entityNamePattern =
    /^(?!.*[&.,'.-]{2})(?!.*\s{2})(?! )[A-Za-z0-9](?:[A-Za-z0-9\s&.,'.-]*[A-Za-z0-9])?$/;
  static readonly dateFormatPattern =
    /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  static readonly IsoDatePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
  static readonly filterSlashDatePattern =
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    static readonly numericPattern = /(\d+)\s*\/\s*(\d+)/;
    static readonly numericDecimalPattern = /^\d+(\.\d+)?$/;
}
